/**
 * Party ECO Member Pass
 */
import { axiosRequest } from '@/plugins/axios-common'

import { handleError } from '@/store/handle-error'

import { PARTY_NAMESPACE } from '@/store/party'

export const ECOMemberPassIntegrationState = {
  eco_member_pass: {
    enabled: false,
  },
}

export const ECOMemberPassIntegrationActions = {
  fetchECOMemberPass: async (_, requestData) => {
    if (!requestData?.passId) {
      throw new Error('Pass ID is required')
    }

    return axiosRequest.
      get(`/admin/eco_member_pass/passes/${requestData.passId}`).
      then(({ data }) => {
        return data
      }).
      catch(handleError)
  },

  fetchECOMemberPasses: async ({ commit }, requestData) => {
    return axiosRequest.
      get(`/admin/eco_member_pass/parties/${requestData.partyId}`).
      then(({ data }) => {
        commit(`${PARTY_NAMESPACE}/pePatchParty`, { eco_member_passes: data.eco_member_passes }, { root: true })
        return data
      }).
      catch(handleError)
  },

  ecoMemberPassEnabled: async ({ commit }) => {
    return axiosRequest.
      get('/admin/eco_member_pass/enabled').
      then(({ data }) => commit('setECOMemberPassEnabled', data?.enabled || false)).
      catch(handleError)
  },

  issueECOMemberPass: async ({ commit }, requestData) => {
    return axiosRequest.
      post('/admin/eco_member_pass/issue', { eco_member_pass: requestData }).
      then(({ data }) => {
        commit(`${PARTY_NAMESPACE}/pePatchParty`, { eco_member_passes: data.eco_member_passes }, { root: true })
        return data
      }).
      catch(handleError)
  },
}

export const ECOMemberPassIntegrationGetters = {
  isECOMemberPassEnabled: state => state.eco_member_pass.enabled,
}

export const ECOMemberPassIntegrationMutations = {
  setECOMemberPassEnabled: (state, data) => (state.eco_member_pass.enabled = data),
}
